import React, { useState } from "react";
import {
  ButtonEnter,
  Container,
  Content,
  LinhaVertical,
  Space,
  TitleButtonEnter,
  TitleInput,
  Title,
  DivImg,
  Img,
} from "./style";
import { FormikHelpers, Formik, Form } from "formik";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import StepBasicInfo from "@/components/register-user/seller/StepBasicInfo";
import StepAddress from "@/components/register-user/seller/StepAddress";
import StepAccess from "@/components/register-user/seller/StepAccess";
import StepHowDidYouKnow from "@/components/register-user/seller/StepHowDidYouKnow";
import { useAuth } from "@/context/AuthContext";
import axios from "axios";
import { baseSeller } from "@/utils/server/api";
import { toast, ToastContainer } from "react-toastify";
import Footer from "@/components/footer/footer";
import ButtonSelect from "@/components/button-select/ButtonSelect";
import logo from "@/assets/images/new-logo.png";
import { BeatLoader } from "react-spinners";

const steps = ["Dados", "Endereço", "Senha", "Origem"];

const RegisterSeller = () => {
  const [selectedOption, setSelectedOption] = useState<number>(1);
  const [step, setStep] = useState(0);
  const [businessAgentsValue, setBusinessAgentsValue] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState(false);
  const { registerError } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSelectChange = (option: number) => {
    setSelectedOption(option);
  };

  const initialValues = {
    type: selectedOption,
    business_name: "",
    corporate_name: "",
    document: "",
    cnpj: "",
    state_registration: "",
    phone: "",
    email: "",
    password: "",
    confirm_password: "",
    options_about: "",
    business_agents_name: "",
    zip_code: "",
    street: "",
    house_number: "",
    complement: "",
    neighborhood: "",
    federal_unity: "",
    city: "",
    full_address: "",
    lat: "",
    lng: "",
  };

  const handleSubmit = async (
    values: typeof initialValues,
    actions: FormikHelpers<typeof initialValues>
  ) => {
    let data = {};
    if (values.type === 1) {
      data = {
        document_type: "cpf",
        user_type: "seller",
        fullname: values.business_name,
        cpf: values.document.replace(/[^0-9]/g, ""),
        phone: values.phone.replace(/[^0-9]/g, ""),
        email: values.email,
        password: values.password,
        options_about: values.options_about,
        business_agents_name: values.business_agents_name,
        zip_code: values.zip_code,
        street: values.street,
        house_number: values.house_number,
        complement: values.complement,
        neighborhood: values.neighborhood,
        federal_unity: values.federal_unity,
        city: values.city,
        address: values.full_address,
        lat: values.lat,
        lng: values.lng,
      };
    }

    if (values.type === 2) {
      data = {
        document_type: "cnpj",
        user_type: "seller",
        fullname: values.business_name,
        company_name: values.corporate_name,
        cnpj: values.cnpj.replace(/[^0-9]/g, ""),
        state_registration: values.state_registration,
        phone: values.phone.replace(/[^0-9]/g, ""),
        email: values.email,
        password: values.password,
        options_about: values.options_about,
        business_agents_name: values.business_agents_name,
        zip_code: values.zip_code,
        street: values.street,
        house_number: values.house_number,
        complement: values.complement,
        neighborhood: values.neighborhood,
        federal_unity: values.federal_unity,
        city: values.city,
        address: values.full_address,
        lat: values.lat,
        lng: values.lng,
      };
    }

    setIsLoading(true);
    await axios
      .post(`${baseSeller}/create`, data)
      .then(() => {
        toast.success(t("successfully"), {
          position: toast.POSITION.TOP_CENTER,
        });
        setTimeout(function () {
          navigate("/loginSeller");
        }, 3000);
      })
      .catch((error: any) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          const errors = error.response.data.errors;

          Object.keys(errors).forEach((field) => {
            errors[field].forEach((errorMessage: string) => {
              toast.error(t(errorMessage), {
                position: toast.POSITION.TOP_CENTER,
              });
            });
          });
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="flex-1 bg-[url('/background-comprador.png')] bg-cover bg-no-repeat min-h-screen">
        <div className="flex items-start">
          <Space>
            <DivImg>
              <Img src={logo} alt="Logo da ecolife" />
            </DivImg>
          </Space>
          <LinhaVertical />
          <div className="flex flex-col justify-center items-center w-[50%] py-10">
            <div className="!shadow-2xl rounded-2xl backdrop-blur-sm bg-white/60 flex flex-col items-center p-6">
              <Title>{t("comment-seller")}</Title>
              <ButtonSelect onSelectChange={handleSelectChange} options="all" />
              <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                <Form>
                  {step === 0 && (
                    <StepBasicInfo
                      selectedOption={selectedOption}
                      registerError={registerError}
                    />
                  )}
                  {step === 1 && <StepAddress />}
                  {step === 2 && <StepAccess />}
                  {step === 3 && (
                    <StepHowDidYouKnow
                      businessAgentsValue={businessAgentsValue}
                      setBusinessAgentsValue={setBusinessAgentsValue}
                    />
                  )}

                  <div className="mt-6 flex justify-between">
                    {step > 0 && (
                      <button
                        className="!bg-amber-500 !px-4 !py-2 !text-white !font-medium rounded-sm"
                        type="button"
                        onClick={() => setStep((s) => s - 1)}
                      >
                        Voltar
                      </button>
                    )}
                    {step === steps.length - 1 ? (
                      <button
                        className="!bg-[#50700F] !px-4 !py-2 !text-white !font-medium rounded-sm"
                        type="submit"
                      >
                        {isLoading ? (
                          <BeatLoader className="spinner" color="white" />
                        ) : (
                          t("register")
                        )}
                      </button>
                    ) : (
                      <button
                        className="!bg-[#2196F3] !px-4 !py-2 !text-white !font-medium rounded-sm"
                        type="button"
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                          e.preventDefault();
                          setStep((s) => s + 1);
                        }}
                      >
                        Próximo
                      </button>
                    )}
                  </div>
                </Form>
              </Formik>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
      <Footer />
    </>
  );
};

export default RegisterSeller;
